import { render, staticRenderFns } from "./PageErrorWentWrong.vue?vue&type=template&id=e5be4a4a"
import script from "./PageErrorWentWrong.vue?vue&type=script&lang=js"
export * from "./PageErrorWentWrong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports